<template>
  <div>
    <section
      v-for="([sec, comp], i) of sectionComponents"
      :key="i"
      class="dynamic-section"
      @play-now-clicked="$emit('play-now-clicked')"
    >
      <component
        :is="comp"
        :section="sec"
        @play-now-clicked="$emit('play-now-clicked')"
      />
    </section>
  </div>
</template>

<script>
import BannerLikeSection from './BannerLikeSection.vue';
import CompareImagesSection from './CompareImagesSection.vue';
import CountingSection from './CountingSection.vue';
import GalleryGridImagesSection from './GalleryGridImagesSection.vue';
import GalleryImagesSection from './GalleryImagesSection.vue';
import InstagramSection from './InstagramSection.vue';
import ProgramHistorySection from './ProgramHistory.vue';
import SplitImageSection from './SplitImageSection.vue';
import SquareBoxBackgroundSection from './SquareBoxBackgroundSection.vue';
import SquareBoxSection from './SquareBoxSection.vue';
import TextBlockSection from './TextBlockSection.vue';
import ThreeBarSection from './ThreeBarSection.vue';
import TimelineSection from './TimelineSection.vue';
import TwoBlockSection from './TwoBlockSection.vue';
import VideoPopupSection from './VideoPopupSection.vue';

export default {
  name: 'DynamicSections',

  props: {
    sections: { type: Array, default: () => [] }
  },

  computed: {
    sectionComponents() {
      const sections = this.sections || [];

      return sections.map((sec) => {
        let comp;
        switch (sec.acf_fc_layout) {
          case 'split_image': comp = SplitImageSection; break;
          case 'banner_like': comp = BannerLikeSection; break;
          case 'video_popup': comp = VideoPopupSection; break;
          case 'compare_images': comp = CompareImagesSection; break;
          case 'gallery_images': comp = GalleryImagesSection; break;
          case 'gallery_grid_images': comp = GalleryGridImagesSection; break;
          case 'program_history': comp = ProgramHistorySection; break;
          case 'timeline': comp = TimelineSection; break;
          case 'counting_numbers': comp = CountingSection; break;
          case 'instagram': comp = InstagramSection; break;
          case 'three_bar': comp = ThreeBarSection; break;
          case 'square_box': comp = SquareBoxSection; break;
          case 'square_box_w_background_image': comp = SquareBoxBackgroundSection; break;
          case 'two_block': comp = TwoBlockSection; break;
          case 'text_block': comp = TextBlockSection; break;
          default:
        }

        return [sec, comp];
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.dynamic-section::v-deep {
  &:first-child .container {
    padding-top: 100px;
  }

  &:last-child .container {
    padding-bottom: 60px;
  }

  .container {
    padding-top: 60px;

    @media screen and (min-width: $breakpoint-lg) {
      padding-top: 50px;
      padding-bottom: 50px;
    }

    h2 {
      text-align: left;
      font-size: 28px;
      line-height: 42px;
      font-stretch: condensed;
      font-weight: 700;
      margin: 0;
      text-transform: uppercase;
      hyphens: manual;

      @media screen and (min-width: $breakpoint-lg) {
        font-size: 52px;
        line-height: 52px;
      }

      strong {
        display: block;
        font-family: 'Yearbook Solid W01', sans-serif;
        font-size: 36px;
        font-weight: 400;
        line-height: 40px;

        @media screen and (min-width: $breakpoint-lg) {
          font-size: 60px;
          line-height: 70px;
        }
      }
    }

    .content {
      color: $thd-dark-gray;
      font-size: 20px;
      line-height: 35px;

      @media screen and (min-width: $breakpoint-lg) {
        line-height: 36px;
      }

      strong,
      b {
        color: $thd-darker-gray;
        font-weight: 700;
        font-size: 20px;
        line-height: 28px;

        @media screen and (min-width: $breakpoint-lg) {
          font-size: 20px;
          line-height: 36px;
        }
      }

      > *:first-child {
        margin-top: 0;
      }

      > *:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
